import React from "react";
import { Helmet } from "react-helmet-async";
import AiChatBox from "@components/AiChatBox";
import { Box, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";

const ChatAI: React.FC = () => {
  const [searchParams] = useSearchParams();

  const id = searchParams.get("id");
  const token = searchParams.get("token");

  const hasParams = Boolean(id && token);

  return (
    <>
      <Helmet>
        <title>AI Chat Box</title>
      </Helmet>

      {hasParams ? (
        <Box
          sx={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <AiChatBox serviceId={id!} serviceToken={token!} />
        </Box>
      ) : (
        <Box display="flex" alignItems="center" justifyContent="center" textAlign="center" px={2}>
          <Typography variant="h6" color="text.secondary">
            Üzgünüz, <br />
            <strong>id</strong> ve <strong>token</strong> bilgisine ulaşılamadı. <br />
            Lütfen teknik ekipten yardım isteyiniz.
          </Typography>
        </Box>
      )}
    </>
  );
};

export default ChatAI;
